import { createRouter, createWebHistory } from 'vue-router';

const routes = [
	{
		path: '/',
		name: 'Index',
		component: () => import('../views/Index.vue'),
	},
	// About
	{
		path: '/news',
		name: 'NewsList',
		component: () => import('../views/ListCard.vue'),
		props: {
			mode: 'news',
		},
	},
	{
		path: '/news/:id',
		name: 'News',
		component: () => import('../views/News.vue'),
	},
	{
		path: '/intro',
		name: 'Intro',
		component: () => import('../views/Intro.vue'),
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () => import('../views/Contact.vue'),
	},
	{
		path: '/archive',
		name: 'Archive',
		component: () => import('../views/Archive.vue'),
	},
	{
		path: '/sponsor',
		name: 'Sponsor',
		component: () => import('../views/Sponsor.vue'),
	},
	// Competition
	{
		path: '/judge',
		name: 'Judge',
		component: () => import('../views/ListCard.vue'),
		props: {
			mode: 'judge',
		},
	},
	{
		path: '/nominee',
		name: 'Nominee',
		component: () => import('../views/Nominee.vue'),
	},
	{
		path: '/rule',
		name: 'Rule',
		component: () => import('../views/Rule.vue'),
	},
	{
		path: '/topic',
		name: 'Topic',
		component: () => import('../views/Topic.vue'),
	},
	{
		path: '/video',
		name: 'VideoList',
		component: () => import('../views/VideoList.vue'),
	},
	{
		path: '/video/:id',
		name: 'Video',
		component: () => import('../views/Video.vue'),
		beforeEnter: (to, from, next) => {
			let result = require(`@/assets/data/video_tw.yaml`).filter(
				item => item.id == to.params.id
			);
			if (result.length) {
				next();
			} else {
				next({ name: 'Index' });
			}
		},
	},
	{
		path: '/faq',
		name: 'FAQ',
		component: () => import('../views/FAQ.vue'),
	},
	{
		path: '/ott',
		name: 'OTT',
		component: () => import('../views/OTT.vue'),
	},
	// {
	// 	path: '/campaign',
	// 	name: 'Campaign',
	// 	component: () => import('../views/Campaign.vue'),
	// },
	// {
	// 	path: '/components',
	// 	name: 'Components',
	// 	component: () => import('../views/Components.vue'),
	// },
	// {
	// 	path: '/test',
	// 	name: 'Test',
	// 	component: () => import('../views/Test.vue'),
	// },
	{
		path: '/:catchAll(.*)',
		name: '404',
		component: () => import('../views/404.vue'),
		// redirect: '/',
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return {};
		} else {
			window.scrollTo(0, 0);
			return { x: 0, y: 0 };
		}
	},
});

export default router;
